export default {
	vipBenefits: {
		salaryTitle: 'Gaji VIP',
		benefitsTitle: 'Faedah',
		yourVipProgress: 'Kemajuan VIP Anda',
		progressToVip: '{percent}% ke VIP {level}',
		vipMax: 'Tahap Maksimum Dicapai',
		vipLevelBenefits: 'Tahap & Faedah VIP',
		betXpRule: 'Pertaruhan {amount} = {xp}EXP',
		btnReceive: 'Terima',
		btnJoinIn: 'Sertai',
		btnReceived: 'Diterima',
		btnExpired: 'Tamat Tempoh',
		btnNotSettled: 'Belum Diselesaikan',
		btnComingSoon: 'Akan Datang',
		btnViewMore: 'Lihat Lagi',
		btnContactNow: 'Hubungi',
		guestTitleLevelup: 'Bonus Naik Tahap',
		guestTitleDaily: 'Gaji Harian',
		guestTitleWeekly: 'Gaji Mingguan',
		guestTitleMonthly: 'Gaji Bulanan',
		guestTitleCashback: 'Pulangan Tunai',
		guestTitleRescue: 'Bonus Penyelamat',
		guestTitleEvents: 'Acara VIP',
		guestTitleSupport: 'Sokongan VIP',
		guestDescLevelup: 'Dapatkan bonus sekali setiap kali anda mencapai tahap VIP baharu.',
		guestDescDaily: 'Tuntut ganjaran gaji harian apabila tahap VIP anda meningkat.',
		guestDescWeekly: 'Tuntut ganjaran gaji mingguan apabila tahap VIP anda meningkat.',
		guestDescMonthly: 'Tuntut ganjaran gaji bulanan apabila tahap VIP anda meningkat.',
		guestDescCashback: 'Peroleh pulangan tunai daripada perbelanjaan permainan anda.',
		guestDescRescue: 'Dapatkan bonus penyelamat untuk membantu anda bangkit semula.',
		guestDescEvents: 'Tahap VIP lebih tinggi membuka lebih banyak ganjaran acara eksklusif.',
		guestDescSupport: 'Sokongan VIP khusus untuk bantuan lebih pantas.',
		comingSoonHint: 'Faedah akan datang, nantikan',
		receiveSuccess: 'Ganjaran diterima',
		receiveFailed: 'Gagal menerima ganjaran',
		typeUpgrade: 'Bonus Naik Tahap',
		typeDailySalary: 'Gaji Harian',
		typeWeeklySalary: 'Gaji Mingguan',
		typeMonthlySalary: 'Gaji Bulanan',
		typeRebate: 'Pulangan Tunai',
		typeRescue: 'Bonus Penyelamat',
		typeVipActivity: 'Acara VIP',
		typeVipService: 'Sokongan VIP',
		tooltipRecharge: 'Tambah nilai {current}/{target}',
		tooltipBets: 'Pertaruhan {current}/{target}',
		progressRecharge: 'Tambah nilai',
		progressBets: 'Pertaruhan',
		descUpgradeBonus: 'Bonus Naik Taraf VIP{level} ×{count}',
		descDailySalary: 'Gaji Harian VIP{level} ×{count}',
		descWeeklySalary: 'Gaji Mingguan VIP{level} ×{count}',
		descMonthlySalary: 'Gaji Bulanan VIP{level} ×{count}',
		descUpgradeBonusPlain: 'Bonus Naik Taraf VIP{level}',
		descDailySalaryPlain: 'Gaji Harian VIP{level}',
		descWeeklySalaryPlain: 'Gaji Mingguan VIP{level}',
		descMonthlySalaryPlain: 'Gaji Bulanan VIP{level}',
		descRebate: 'Pulangan Tunai Permainan VIP{level}',
		descRescue: 'Bonus Penyelamat VIP{level}',
		descVipActivity: 'Tahap VIP lebih tinggi membuka lebih banyak ganjaran acara eksklusif.',
		descVipService: 'Sokongan VIP khusus untuk bantuan lebih pantas.',
		allBenefits: 'Semua Faedah',
		vipClubTitle: 'VIP Club',
		more: 'Lagi',
		moreDesc: 'Sila lihat promosi kami untuk butiran lanjut.',
		promotions: 'Promosi',
		highlightsTitle: '8 Ciri Utama',
		highlightSupport: 'Sokongan VIP Eksklusif',
		highlightLevelup: 'Bonus Naik Tahap',
		highlightSalary: 'Gaji VIP',
		highlightRescue: 'Bonus Penyelamat VIP',
		highlightGifts: 'Hadiah\nEksklusif VIP',
		highlightEvents: 'Acara VIP',
		highlightService: 'Perkhidmatan\nVIP Khas',
		highlightWallet: 'Dompet\nKredit VIP',
		currentLevel: 'Tahap Semasa',
		keepPlayingReach: 'Terus bermain untuk mencapai',
		higherLevelRewards: 'Semakin tinggi tahap, semakin besar ganjaran',
		levelUpUnlock: 'Naik tahap untuk membuka faedah eksklusif dan nikmati pengalaman premium.',
		yourVipBenefits: 'Faedah VIP Anda',
		viewVipLevels: 'Lihat Tahap VIP',
		exclusiveBenefitsTitle: 'Faedah Eksklusif Anda',
		tipExclusiveRewards: 'Ganjaran Eksklusif',
		tipHigherRakeback: 'Rebat Lebih Tinggi',
		tipPrioritySupport: 'Sokongan Keutamaan',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Tahap',
		tableRequiredXp: 'EXP Diperlukan',
		tableLevelUpBonus: 'Bonus naik tahap',
		tableDailyRakeback: 'Rebat harian',
		tableWeeklyLossback: 'Pulangan kerugian mingguan',
		signIn: 'Log Masuk',
		vipClubDefaultDesc: 'Sertai VIP Club kami sekarang dan bersedia untuk menerima hadiah, cabutan dan pelbagai ciri menarik.',
	},
};
